"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var DynoSchedulingSpacing =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DynoSchedulingSpacing, _PureComponent);

  function DynoSchedulingSpacing() {
    (0, _classCallCheck2.default)(this, DynoSchedulingSpacing);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DynoSchedulingSpacing).apply(this, arguments));
  }

  (0, _createClass2.default)(DynoSchedulingSpacing, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIBox.default, {
        className: "m-left-3 m-right-3 m-bottom-2"
      }, _react.default.createElement(_UIIcon.default, {
        name: "next",
        size: "xxs"
      }));
    }
  }]);
  return DynoSchedulingSpacing;
}(_react.PureComponent);

exports.default = DynoSchedulingSpacing;
module.exports = exports.default;